// Mirrors backend com.kervolt.oms.dataclass.bank.{BankAccountDTO,BankAccountCreateDTO} 1:1.

export interface BankAccount {
    id: string;
    institutionId: string;
    glCashAccountId: string;
    glCashAccountCode?: string;
    glCashAccountName?: string;
    bankName: string;
    accountNumber: string;
    branchName?: string;
    /** Foreign-currency account code; null/absent = BDT. Bank balances are revalued at month-end. */
    currencyCode?: string | null;
    /** W3-H. */
    accountType?: BankAccountType | null;
    overdraftLimit?: number | null;
}

export type BankAccountType = 'CURRENT' | 'SND' | 'SAVINGS' | 'FC' | 'ERQ' | 'OD' | 'CASH_CREDIT' | 'OTHER';

export const BANK_ACCOUNT_TYPES: BankAccountType[] =
    ['CURRENT', 'SND', 'SAVINGS', 'FC', 'ERQ', 'OD', 'CASH_CREDIT', 'OTHER'];

export interface BankAccountCreateDTO {
    bankName: string;
    accountNumber: string;
    branchName?: string;
    glCashAccountId: string;
    institutionId: string;
    currencyCode?: string | null;
    accountType?: BankAccountType | null;
    overdraftLimit?: number | null;
}
